import { HttpClient } from "@angular/common/http";
import { Injectable, NgZone } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { BaseService } from "../../@core/services/base.service";
import { environment } from '../../../environments/environment.dev';
import { IAttachment } from "src/app/@core/models/model";
import { ResponseJson } from "src/app/@core/models/model";

export type AttachmentWithSignedUrl = IAttachment & { fullUrl: string; expiresAt?: number };

@Injectable({ providedIn: 'root' })
export class AttachmentService extends BaseService {
    private signedUrlCache = new Map<string, { data: AttachmentWithSignedUrl; expiresAt: number }>();

    constructor(
        protected override http: HttpClient,
        protected ngZone: NgZone
    ) {
        super(http, ngZone);
    }

    apiUrl = environment.apiUrl + '/attachment'

    getAttachmentWithSignedUrl(attachmentId: string, versionId?: string): Observable<ResponseJson<AttachmentWithSignedUrl>> {
        const cacheKey = versionId ? `${attachmentId}-${versionId}` : attachmentId;
        const cached = this.signedUrlCache.get(cacheKey);
        const now = Date.now();
        if (cached && cached.expiresAt > now) {
            return of({ success: true, message: 'Attachment retrieved successfully', data: cached.data });
        }
        const params = versionId ? { versionId } : undefined;
        return this.get<AttachmentWithSignedUrl>(this.apiUrl + '/signed-url/' + attachmentId, params).pipe(
            tap(res => {
                if (res.success && res.data) {
                    const expiresAt = typeof res.data.expiresAt === 'number'
                        ? res.data.expiresAt
                        : now + 23 * 60 * 60 * 1000;
                    this.signedUrlCache.set(cacheKey, { data: res.data, expiresAt });
                    if (this.signedUrlCache.size > 20) this.clearExpired();
                }
            })
        );
    }

    private clearExpired(): void {
        const now = Date.now();
        for (const [id, entry] of this.signedUrlCache) {
            if (entry.expiresAt <= now) this.signedUrlCache.delete(id);
        }
    }
}